//TestBookMockExamList.jsx
import React, {  useMemo, useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import './styles/MCQPractice.css';
import { useSelector } from 'react-redux';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import CertificateRenderer from '../assesstment/CertificateRenderer';

const TestBookMockExamList = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [userId, setUserId] = useState(authState.user._id);

    const [selectedSetId, setSelectedSetId] = useState('');
    const [setMasterList, setSetMasterList] = useState([]);
    const [examSetList, setExamSetList] = useState([]);
    const [selectedExamSetId, setSelectedExamSetId] = useState('');

    const [examMaster, setExamMaster] = useState([]);
    const [isRepeated, setIsRepeated] = useState(0);

    const fetchSetMasters = useCallback(() => {
        const config = {
            url: "/ttbsetmaster/ttbmocksets",
            method: "post",
            headers: { Authorization: authState.token },
            data: { setType: "Certification" }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.setlist)) {
                    setSetMasterList(response.setlist);
                } else {
                    console.error("Set master list error");
                }
            })
            .catch(error => {
                console.error("Error fetching set masters:", error);
            });
    }, [authState.token, fetchData]);

    const fetchExamSetList = useCallback(() => {
        const config = {
            url: "/ttbmyexamsets/myttbsets",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId, setQuestionType: "Certification" }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.examsetlist)) {
                    setExamSetList(response.examsetlist);
                } else {
                    console.error("Exam set not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching exam list:", error);
            });
    }, [authState.token, userId, fetchData]);

    useEffect(() => {
        if (authState.isLoggedIn) {
            fetchSetMasters();
            fetchExamSetList();
        }
    }, [authState.isLoggedIn, fetchSetMasters, fetchExamSetList]);

    const sortedSetMasterList = useMemo(() => {
        return [...setMasterList].sort((a, b) => a.setDisplaySn - b.setDisplaySn);
    }, [setMasterList]);

    const sortedExamSetList = useMemo(() => {
        return [...examSetList].sort((a, b) => new Date(b.dateExam) - new Date(a.dateExam));
    }, [examSetList]);

    useEffect(() => {
        const newExamMaster = sortedExamSetList.map(examSet => {
            return sortedSetMasterList.find(setMaster => setMaster._id === examSet.setId) || null;
        }).filter(Boolean);
        setExamMaster(newExamMaster);
    }, [sortedSetMasterList, sortedExamSetList]);

    const handleSetMasterView = setId => {
        setSelectedSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleExamSetView = setId => {
        setSelectedExamSetId(prevId => (prevId === setId ? null : setId));
    };

    const handleExamClick = (setId, setTitle, seriesId, seriesTitle, examId, examTitle, examType, timeLimitInMin, isRepeated) => {
        navigate('/testbook-mockexam', { state: { setId, setTitle, seriesId, seriesTitle, examId, examTitle, examType, timeLimitInMin, isRepeatExam: isRepeated } });
    };

    function convertTimeLimit(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const formattedTimeLimit = `${hours}:${remainingMinutes} (Hr:Min)`;
        return formattedTimeLimit;
    }

    function convertTimeTaken(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const remainingMinutes = Math.floor((milliseconds % 3600000) / 60000);
        const remainingSeconds = Math.floor((milliseconds % 60000) / 1000);
        const remainingMilliseconds = milliseconds % 1000;
        const formattedTime = `${hours}:${remainingMinutes
            .toString()
            .padStart(2, "0")}:${remainingSeconds
                .toString()
                .padStart(2, "0")}.${remainingMilliseconds
                    .toString()
                    .padStart(3, "0")} (Hr:Min:Sec)`;
        return formattedTime;
    }

    return (
        <MainLayout>
            <div className="min-h-screen py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-12 mb-2">
                <h3 className='text-xl font-bold text-white text-center mb-4'>Mock Certification Tests</h3>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className='mx-4'>
                            <div className="flex flex-col">
                                <div className='flex flex-col'>
                                    <div>
                                        {setMasterList && setMasterList.length === 0 ? (
                                            <div className='h-[300px] flex items-center justify-center text-yellow-300'>
                                                No records found!
                                            </div>
                                        ) : (
                                            sortedSetMasterList.map((setMaster, index) => (
                                                <div key={setMaster._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                                                    <div className='flex'>
                                                        <span className={examMaster.some(exam => exam._id === setMaster._id) ? 'font-medium text-yellow-500' : 'font-medium'}>
                                                            {index + 1}. 
                                                        </span>
                                                        <span className={setMaster?.setTitle?.includes("Mock") ? "text-orange-600" : "textblack"}>
                                                            {setMaster.setTitle}
                                                        </span>
                                                        <Tooltip text={"View details"} position={"top"}>
                                                            <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleSetMasterView(setMaster._id)}>
                                                                <i className="fa-solid fa-eye"></i>
                                                            </span>
                                                        </Tooltip>
                                                        {/* {"SetMaster isT5W: "}{setMaster.isT5w} */}
                                                        <button
                                                            className={`ml-4 px-2 py-1 text-white rounded${examMaster.find(item => item._id === setMaster._id) ? ' bg-blue-500' : ' bg-green-500'}`}
                                                            onClick={() => handleExamClick(setMaster._id, setMaster.setTitle, setMaster.seriesId, setMaster.seriesTitle, setMaster.examId, setMaster.examTitle, setMaster.examType, setMaster.timeLimitInMin, examMaster.find(item => item._id === setMaster._id) ? 1 : 0)}
                                                            style={{ maxWidth: '150px' }}
                                                        >
                                                            {examMaster.find(item => item._id === setMaster._id) ? "Repeat Exam" : "Start Exam"}
                                                        </button>
                                                    </div>
                                                    <div className='text-blue-700'>{setMaster.setDesc}</div>
                                                    {selectedSetId === setMaster._id && (
                                                        <div className='bg-gray-200 text-black'>
                                                            <h2 className='text-blue-600'><strong>{setMaster.setTitle}</strong></h2>
                                                            <p><strong>Total Questions:</strong> {setMaster.setTotalQuestions}</p>
                                                            <p><strong>Time Limit (In Minutes):</strong> {setMaster.timeLimitInMin}</p>
                                                            <p><strong>Marks for Correct Answer:</strong> {setMaster.correctAnswerPoints}</p>
                                                            <p><strong>Marks for Wrong Answer:</strong> {setMaster.WrongAnswerPoints}</p>
                                                            <p><strong>Exam Type:</strong> {setMaster.examType}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                                <div className='flex flex-col'>
                                    <h2 className="md:ml-0 text-white bg-blue-600 rounded p-2">My Exam List</h2>
                                    <div>
                                        {examSetList && examSetList.length === 0 ? (
                                            <div className='h-[300px] flex items-center justify-center text-yellow-300'>
                                                No records found!
                                            </div>
                                        ) : (
                                            sortedExamSetList.map((examSet, index) => (
                                                <div key={examSet._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                                                    <div className='flex'>
                                                        <span className='font-medium'>{index + 1}. {examSet.examTitle},  Date: {examSet.dateExam}</span>
                                                        <Tooltip text={"View details"} position={"top"}>
                                                            <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleExamSetView(examSet._id)}>
                                                                <i className="fa-solid fa-eye"></i>
                                                            </span>
                                                        </Tooltip>
                                                        {/* <Tooltip text={"View details"} position={"top"}>
                                                            <span className='ml-2 mr-2 text-blue-500 cursor-pointer' onClick={() => handleCertificateView(examSet._id)}>
                                                                <i className="fa-solid fa-certificate"></i>
                                                            </span>
                                                        </Tooltip> */}
                                                    </div>
                                                    {selectedExamSetId === examSet._id && (
                                                        <div className='bg-gray-600 text-white mt-4 p-4 rounded-md'>
                                                            <h2 className='text-blue-600 text-lg md:text-xl font-bold'>{examSet.examTitle}</h2>
                                                            <p><strong>Exam Code:</strong> {examSet.practiceCode}</p>
                                                            <p><strong>Exam Date:</strong> {new Date(examSet.dateExam).toLocaleDateString()}</p>
                                                            <p><strong>Is Repeated:</strong> {examSet.isRepeatExam === 1 ? 'Yes' : 'No'}</p>
                                                            <p><strong>Time Limit:</strong> {convertTimeLimit(examSet.timeLimit)}</p>
                                                            <p><strong>Time Taken:</strong> {convertTimeTaken(examSet.timeTaken)}</p>
                                                            <p><strong>Number of Questions:</strong> {examSet.numberOfQuestions}</p>
                                                            <p><strong>Correct Answers:</strong> {examSet.correctAnswers}</p>
                                                            <p><strong>Full Marks:</strong> {examSet.fullMarks}</p>
                                                            <p><strong>Marks Obtained:</strong> {examSet.marksObtained}</p>
                                                            <p><strong>Percentage:</strong> {examSet.percentage}%</p>
                                                            <div className="progress-container">
                                                                <div className="progress-bar">
                                                                    <div className="progress" style={{ width: `${examSet.percentage}%` }}>
                                                                        {`${examSet.percentage}%`}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    { viewingCertificate && (
                                                        <CertificateRenderer />
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                {/* </div> */}
            </div>
        </MainLayout>
    );
};

export default TestBookMockExamList;
